"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _default = function _default(identifier) {
  var types = {
    UPDATE_DATA: "[" + identifier + "] Update data",
    UPDATE_LOADING: "[" + identifier + "] Update loading",
    UPDATE_ERROR: "[" + identifier + "] Update error",
    LOAD_DATA: "[" + identifier + "] Load data",
    RESET_STORE: "[" + identifier + "] Reset store"
  };
  return {
    types: types,
    actions: {
      resetStore: function resetStore() {
        return {
          type: types.RESET_STORE
        };
      },
      updateData: function updateData(payload) {
        return {
          type: types.UPDATE_DATA,
          payload: payload
        };
      },
      loadData: function loadData() {
        return {
          type: types.LOAD_DATA
        };
      },
      updateLoading: function updateLoading(payload) {
        return {
          type: types.UPDATE_LOADING,
          payload: payload
        };
      },
      updateError: function updateError(_ref) {
        var _ref$message = _ref.message,
            message = _ref$message === void 0 ? "" : _ref$message,
            _ref$type = _ref.type,
            type = _ref$type === void 0 ? "none" : _ref$type;
        return {
          type: types.UPDATE_ERROR,
          payload: {
            message: message,
            type: type
          }
        };
      }
    }
  };
};

exports["default"] = _default;